module.exports = __webpack_public_path__ + "img/dr_2.3b84e7f0.png";